import { ArrowRight } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { LINKEDIN_URL } from "../data/products";

export const About = () => {
  return (
    <section
      id="about"
      data-testid="about"
      className="bg-surface"
    >
      <div className="mx-auto max-w-5xl px-6 py-12 md:py-16 lg:px-8">
        <div className="grid gap-8 md:grid-cols-[1.4fr_1fr] md:items-start md:gap-14">
          {/* Left — heading + description */}
          <div>
            <Reveal>
              <Eyebrow>About MisiDigi</Eyebrow>
            </Reveal>
            <Reveal delay={0.05}>
              <h2 className="mt-5 font-bold leading-[1.08] tracking-tight text-ink text-[clamp(1.9rem,4.4vw,2.6rem)] text-balance">
                A small studio building useful digital products for everyday
                needs.
              </h2>
            </Reveal>
            <Reveal delay={0.1}>
              <div className="mt-6 space-y-5 text-[17px] leading-relaxed text-slatetx">
                <p>
                  MisiDigi (Misi Digital Indonesia) is an independent digital
                  product studio founded by Hendri Kurniawan.
                </p>
                <p>
                  We combine product strategy, consumer insight, design, and
                  modern development to turn practical ideas into focused
                  digital products.
                </p>
              </div>
            </Reveal>
          </div>

          {/* Right — founder card */}
          <Reveal delay={0.15}>
            <div className="rounded-[20px] border border-hairline bg-surface p-8">
              <div className="flex items-center gap-5">
                <div className="h-[84px] w-[84px] shrink-0 overflow-hidden rounded-full ring-1 ring-hairline">
                  <img
                    src="/hendri.jpeg"
                    alt="Hendri Kurniawan, Founder of MisiDigi Studio"
                    loading="lazy"
                    className="h-full w-full object-cover object-top"
                  />
                </div>
                <div>
                  <p className="text-[18px] font-semibold text-ink">
                    Hendri Kurniawan
                  </p>
                  <p className="mt-1 text-[13px] font-semibold text-steel">
                    Founder
                  </p>
                  <p className="mt-1.5 text-[13px] leading-relaxed text-platinum">
                    Commercial Leader · Digital Product Builder
                  </p>
                </div>
              </div>
              <div className="mt-6 border-t border-hairline pt-5">
                <a
                  data-testid="about-linkedin"
                  href={LINKEDIN_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group inline-flex items-center gap-2 text-[14px] font-semibold text-ink"
                >
                  Connect on LinkedIn
                  <ArrowRight
                    size={15}
                    className="transition-transform group-hover:translate-x-1"
                  />
                </a>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
